module.exports = __webpack_public_path__ + "img/D30.dafd02f7.png";